import bg1 from '../assets/images/cadreamfund/ca-dream-fund-background.png';
import bgLogo from '../assets/images/cadreamfund/ca-dream-fund-logo.png';

const roundData = {
  closeDate: '2021-12-08T01:00:00.000+00:00',
  notificationDate: '2021-12-13T08:00:00.000+00:00',
  openDate: '2021-10-29T16:00:00.000+00:00',
};

const buttonText = {
  applyButtonText: 'Apply Now',
  loginButtonText: 'Login',
};

const notificationText = {
  startTime: 'Application will start on',
  timeIsUp: 'The application period is now closed for this program',
};

const programGuideLineButtons = [
  {
    text: 'CA Dream Fund Homepage',
    link: 'https://cadreamfund.com/',
  },
  {
    text: 'Eligibility Requirements',
    link: 'https://cadreamfund.com/#eligibility-requirements',
  },
  {
    text: 'Program and Application Guide',
    link: 'https://cadreamfund.com/#application-guides',
  },
  {
    text: 'Required Documentation',
    link: 'https://cadreamfund.com/#required-documents',
  },
];

const productType = 'CADREAMFUND';

const IDCardDetails = [
  'Government Issued Photo ID',
  'Complete 2019 Federal Tax Return',
  'Complete 2020 Federal Tax Return',
  'Interim Financials (2019 Cumulative Q2, Q3 and Q4 Profit & Loss Statements)',
  'Interim Financials (2020 Cumulative Q2, Q3 and Q4 Profit & Loss Statements)',
];

const docsDetails = [
  '(One of the Following): Articles of Incorporation, Certificate of Organization, Fictitious Name of Registration, or Government-Issued Business License',
  'Bank Verification',
];

const helpfulTips = [
  'Fill in all fields in the application form;',
  'Upload all required documents; and',
  'Verify your bank account.',
];

const landingDetails = {
  backgroundImage: bg1,
  backgroundLogo: bgLogo,
  className: 'cadreamfund',
  status: 'OPEN',
  subTitle1: '',
  subTitle2:
    'The California Dream Fund Program is funded by the State of California and administered by the California Office of the Small Business Advocate (CalOSBA). Eligibility criteria does apply.',
  title: '',
};

export default {
  roundData,
  programGuideLineButtons,
  productType,
  IDCardDetails,
  docsDetails,
  helpfulTips,
  landingDetails,
  buttonText,
  notificationText,
};
